/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_OtherInputs */

const vi_order_channel_other = /** @type {(inputs: Order_Channel_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác`)
};

/**

* @param {Order_Channel_OtherInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_other = /** @type {((inputs?: Order_Channel_OtherInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_OtherInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_other(inputs)
});